import React from 'react'
import { AppBar, BottomNavigation, BottomNavigationAction } from '@mui/material'
import DashboardIcon from '@mui/icons-material/DashboardOutlined'
import AssessmentIcon from '@mui/icons-material/AssessmentOutlined'
import VideoCallIcon from '@mui/icons-material/VideoCallOutlined'
import { useRouter } from 'next/router'
import { ISchool } from '../../../interfaces/school.interface'

export const StudentTeacherDashboardTabs = (_props: {
  schoolDetails: ISchool
}) => {
  // const [tabValue, setTabValue] = React.useState(0);
  const router = useRouter()
  const value = router.pathname
  console.log({ router })

  return (
    <div>
      <div style={{ height: '60px' }} />
      <AppBar
        style={{
          zIndex: 1200,
          // boxShadow: "none",
          backgroundColor: '#fff',
          bottom: '0px',
          top: 'auto',
          overflowX: 'auto',
          boxShadow: 'none',
          borderTop: '1px solid #7575752b',
        }}
        position="fixed"
        color="inherit"
        // variant="outlined"
      >
        <BottomNavigation
          value={value}
          // onChange={(_event, newValue) => {
          //   setTabValue(newValue);
          // }}
          showLabels
          // className={classes.root}
        >
          <BottomNavigationAction
            label="Courses"
            value={'/dashboard'}
            onClick={() => {
              router.push('/dashboard')
            }}
            // href={"/dashboard"}
            icon={<DashboardIcon />}
          />
          {/* {props.schoolDetails.show_forum && (
            <BottomNavigationAction
              value={'/discussion'}
              label="Community"
              // href={"/user-chat"}
              onClick={() => {
                router.push('/discussion')
              }}
              icon={<PeopleIcon />}
            />
          )} */}
          <BottomNavigationAction
            value={'/assessments'}
            label="Quizzes"
            // href={"/assessments"}
            onClick={() => {
              router.push('/assessments')
            }}
            icon={<AssessmentIcon />}
          />
          <BottomNavigationAction
            value={'/schedules'}
            label="Live class"
            // href={"/schedules"}
            onClick={() => {
              router.push('/schedules')
            }}
            icon={<VideoCallIcon />}
          />
          {/* {props.schoolDetails?.show_active_chats && (
            <BottomNavigationAction
              value={'/user-chat'}
              label="Chat"
              // href={"/user-chat"}
              onClick={() => {
                router.push('/user-chat')
              }}
              icon={<ChatBubbleIcon />}
            />
          )} */}
        </BottomNavigation>
      </AppBar>
    </div>
  )
}
